import React, { Component } from 'react';
import Big3Common from "../../js/Big3Common";
/* 개발담당:양유빈
 * 화면기능:상품찜하기
 * 세부설명:
*/

export class GoodsHeart extends Component {
    static displayName = GoodsHeart.name;

    constructor(props) {
        super(props);
        this.state = {
            Bookmark_Yn: null
        };
        this.handle_Click = this.handle_Click.bind(this);
        this.Uid = "";          //도매 uid
        this.Goods_No = "";     //상품번호
        this.Bookmark_Yn = "";  //북마크 설정여부
    }
    //초기화
    componentDidMount() {
        
        if (this.props.Bookmark !== undefined && this.props.Bookmark !== null) {
            this.Goods_No = this.props.Bookmark.Goods_No;
            this.Uid = this.props.Bookmark.Uid;
            this.Bookmark_Yn = this.props.Bookmark.Bookmark_Yn;
        } 
    }
    async handle_Click(event, Uid, Goods_No, Bookmark_Yn) {
        
        try {
            let Data = await Big3Common.Post("api/Common/Common/RegisterBokmkGoods",
                {
                    Goods_No: Goods_No,
                    Uid: Uid
                },
                true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let HeartYn = Bookmark_Yn === "Y" ? "N" : "Y";
                this.setState({ Bookmark_Yn: HeartYn });
                if (this.props.CallBack !== undefined) {
                    setTimeout(() => {
                        this.props.CallBack(HeartYn);
                    }, 300);
                }
            }
            else {
                console.log(Data.message);
            }
            event.stopPropagation();
        }
        catch (e) {
            console.log("handle_Click: ", e)
        }

        event.preventDefault();
    }
    render() {

        let HeartYn = this.state.Bookmark_Yn === null ? this.Bookmark_Yn : this.state.Bookmark_Yn;
        let cssName = "heart";
        if (HeartYn === "Y") {
            cssName = "heart_checked";
        }
        return (
            <div className={cssName} onClick={(e) => { e.stopPropagation(); this.handle_Click(e, this.Uid, this.Goods_No, HeartYn); }}></div>
        );
    }
}
